export default {"src":"/_next/static/media/wa-svg-icon.bf0ceb42.svg","height":211,"width":211};